import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { AppBar, CircularProgress, IconButton } from 'material-ui';
import { NavigationClose, NavigationChevronLeft } from 'material-ui/svg-icons';
import { t } from '../i18n';

const styles = {
  appBar: {
    backgroundColor: 'white',
    position: 'fixed',
    top: '0',
    borderBottom: '1px solid #E0E0E0',
  },
  icon: {
    fill: 'black',
    color: 'black',
  },
  input: {
    width: '100%',
    height: '48px',
    border: 'none',
    fontSize: '16px',
    verticalAlign: 'middle',
  },
};

class SearchAppBar extends PureComponent {
  constructor(...args) {
    super(...args);

    this.state = {
      term: '',
    };

    const { onSearch, throttleTime } = this.props;
    this.requestOnSearch = _.throttle(onSearch, throttleTime);
  }

  componentWillUnmount() {
    this.requestOnSearch.cancel();
  }

  handleSearch(term) {
    this.setState({ term },
      () => this.requestOnSearch(term));
  }

  render() {
    const { term } = this.state;
    const {
      onNavigateBack,
      iconElementLeft,
      iconElementRight,
      placeholder,
      isLoading,
      zDepth,
    } = this.props;

    const withSearchTerm = term.length;

    const getBackElement = () => (
      iconElementLeft || (
        <IconButton onClick={onNavigateBack}>
          <NavigationChevronLeft color="black" />
        </IconButton>
      )
    );

    const getLeftElement = () => (
      withSearchTerm ? (
        <IconButton onClick={() => this.handleSearch('')}>
          <NavigationClose color="black" />
        </IconButton>
      ) : getBackElement()
    );

    const getRightElement = () => (
      iconElementRight || (
        isLoading ? (
          <IconButton>
            <CircularProgress size={24} />
          </IconButton>
        ) : null
      )
    );

    const searchField = (
      <input
        value={term}
        onChange={({ target: { value } }) => this.handleSearch(value)}
        type="text"
        style={styles.input}
        placeholder={placeholder}
      />
    );

    return (
      <AppBar
        style={styles.appBar}
        iconStyleLeft={styles.icon}
        iconElementLeft={getLeftElement()}
        iconElementRight={getRightElement()}
        zDepth={zDepth}
        title={searchField}
      />
    );
  }
}

SearchAppBar.propTypes = {
  onNavigateBack: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  throttleTime: PropTypes.number,
  iconElementLeft: PropTypes.node,
  iconElementRight: PropTypes.node,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  zDepth: PropTypes.number,
};

SearchAppBar.defaultProps = {
  throttleTime: 300,
  placeholder: t('Type to search'),
  autoFocus: true,
  zDepth: 0,
};

export default SearchAppBar;



// WEBPACK FOOTER //
// ./src/components/SearchAppBar.js